import axios, { AxiosResponse } from 'axios';

export const getInvites = (): Promise<AxiosResponse> =>
	axios.get(`/auth/users`);

export const sendInvite = (email: string): Promise<AxiosResponse> =>
	axios.post(`/users/invite`, { email });

export const approveInvite = (email: string): Promise<AxiosResponse> =>
	axios.post(`/users/approve`, { email });
